module.exports = __webpack_public_path__ + "img/maintenance2.f31f2b8f.jpeg";